import React from 'react';
import '../template-file-css/document-file-template.css';


export const RNFI_PersonalHxForm = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RNFI_PersonalHxForm' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'><center><h2> Personal History Form</h2></center></p>
                <p className='w-750'><center><h4> Ravens Nest Foundation, Inc.</h4></center></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'> Client's name:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'> Date:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtClientsName' name='txtClientsName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='date' id='txtDate' name='txtDate' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-125'>
                            <span className='eleHeader'> Gender:</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'> Age:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'> Date of Birth:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'> Grade in school:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='radio' id='rbGenderFemale' name='rbGender' className='add-only' value='Female' /> Female &nbsp;

                            <input type='radio' id='rbGenderMale' name='rbGender' className='add-only' value='Male' /> Male
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtAge' name='txtAge' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtDateOfBirth' name='txtDateOfBirth' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtGradeInSchool' name='txtGradeInSchool' className='add-only' />
                        </td>
                    </tr>



                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'> Address:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'> City:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='text' id='txtAddress' name='txtAddress' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtCity' name='txtCity' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'> State:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'> Zip:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'> Phone (home):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtState' name='txtState' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtZip' name='txtZip' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtPhoneHome' name='txtPhoneHome' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <span className='eleHeader'> Phone (work):</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'> Ext:</span>
                        </td>
                        <td className='w-350'>
                            <span className='eleHeader'> Form completed by <span className='small custom-add-only'>(if someone other than client):</span></span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtPhoneWork' name='txtPhoneWork' className='add-only' /></td>
                        <td className='w-200'>
                            <input type='text' id='txtExt' name='txtExt' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtFormCompletedBy' name='txtFormCompletedBy' className='add-only' /></td>
                    </tr>

                </table>

                <p className='w-750'>
                    <span className='eleHeader'> PRIMARY REASON(S) FOR SEEKING SERVICES</span>
                </p>
                <table>
                    <tr>


                        <td className='w-187'><input type='checkbox' name='cbAngerManagement' id='cbAngerManagement' className='add-only' value='AngerManagement' /> Anger Management</td>
                        <td className='w-187'><input type='checkbox' name='cbAnxiety' id='cbAnxiety' className='add-only' value='Anxiety' /> Anxiety</td>
                        <td className='w-187'><input type='checkbox' name='cbCopingSkills' id='cbCopingSkills' className='add-only' value='CopingSkills' /> Coping<br /></td>
                        <td className='w-187'><input type='checkbox' name='cbDepression' id='cbDepression' className='add-only' value='Depression' /> Depression</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' name='cbEatingDisorder' id='cbEatingDisorder' className='add-only' value='EatingDisorder' /> Eating disorder</td>
                        <td className='w-187'><input type='checkbox' name='cbFearPhobias' id='cbFearPhobias' className='add-only' value='FearPhobias' /> Fear/phobias</td>
                        <td className='w-187'><input type='checkbox' name='cbHyperactivity' id='cbHyperactivity' className='add-only' value='Hyperactivity' /> Mental Confusion</td>
                        <td className='w-187'><input type='checkbox' name='cbSexualconcerns' id='cbSexualconcerns' className='add-only' value='Sexualconcerns' /> Sexual concerns</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' name='cbSleepingProblems' id='cbSleepingProblems' className='add-only' value='SleepingProblems' /> Sleeping Problems<br /></td>
                        <td className='w-187'><input type='checkbox' name='cbAddictiveBehaviors' id='cbAddictiveBehaviors' className='add-only' value='AddictiveBehaviors' /> Addictive Behaviors</td>
                        <td className='w-187'><input type='checkbox' name='cbAlcoholDrugs' id='cbAlcoholDrugs' className='add-only' value='AlcoholDrugs' /> Alcohol/Drugs</td>
                        <td className='w-187'><input type='checkbox' name='cbHyperactivity' id='cbHyperactivity' className='add-only' value='Hyperactivity' /> Hyperactivity</td>


                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbOtherMentalHealth' id='cbOtherMentalHealth' className='add-only' value='OtherMentalHealth' /> Other Mental Health Concerns
                            <span className='small custom-add-only'> (specify):&nbsp;</span>

                            <input type='text' id='txOtherMentalHealth' name='txOtherMentalHealth' className='add-only w-350 custom-add-only' /></td>

                    </tr><br />
                </table>

                <p className='w-750'><center><h2> Family History </h2></center></p>

                <h3><b>Parents</b></h3>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'> With whom does the child live at this time?</span></td>
                        <td className='w-375'><span className='eleHeader'> Are parent&#39;s divorced or separated?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtChildLiveWith' name='txtChildLiveWith' className='add-only w-365 custom-add-only' /></td>
                        <td className='w-375'>
                            <input type='radio' id='rbDivorcedOrSeperatedYes' name='rbDivorcedOrSeperated' className='add-only' value='DivorcedOrSeperatedYes' /> Yes &nbsp;
                            <input type='radio' id='rbDivorcedOrSeperatedNo' name='rbDivorcedOrSeperated' className='add-only' value='DivorcedOrSeperatedNo' /> No</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>If yes, who has legal custody?</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Were the child&#39;s parents ever married?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtLegalCustody' name='txtLegalCustody' className='add-only w-365 custom-add-only' /></td>
                        <td className='w-375'>
                            <input type='radio' id='rbParentsEverMarriedYes' name='rbParentsEverMarried' className='add-only' value='ParentsEverMarriedYes' /> Yes &nbsp;
                            <input type='radio' id='rbParentsEverMarriedNo' name='rbParentsEverMarried' className='add-only' value='ParentsEverMarriedNo' /> No</td>
                    </tr><br />

                </table>

                <p className='w-750'><h3><b> Client&#39;s Mother</b></h3></p>




                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'> Name:</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'> Age:</span>
                        </td>
                        <td className='w-450'>
                            <span className='eleHeader'> Occupation:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtClientsMother' name='txtClientsMother' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtClientsMotherAge' name='txtClientsMotherAge' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtClientsMotherOccupation' name='txtClientsMotherOccupation' className='add-only w-350 custom-add-only' />&nbsp;
                            </td>
                            <td className='w-100'>
                            <input type='radio' id='rbMotherOccupationFt' name='rbMotherOccupation' className='add-only' value='Ft' /> FT &nbsp;
                            <input type='radio' id='rbMotherOccupationPt' name='rbMotherOccupation' className='add-only' value='Pt' /> PT
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'> Where employed:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'> Work phone:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtEmployed' name='txtEmployed' className='add-only w-365 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtWorkPhoneMother' name='txtWorkPhoneMother' className='add-only w-365 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'> Mother&#39;s education:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtEducationMother' name='txtEducationMother' className='add-only w-365 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Is the child currently living with mother?</span>
                </p>
                <table>
                    <tr>
                        <td><input type='radio' id='rbLivingWithMotherYes' name='rbLivingWithMother' className='add-only' value='LivingWithMotherYes' /> Yes &nbsp;
                            <input type='radio' id='rbLivingWithMotherno' name='rbLivingWithMother' className='add-only' value='LivingWithMotherNo' /> No
                        </td>
                    </tr>



                    <tr>
                        <td className='w-187'><input type='checkbox' name='cbMotherNaturalParent' id='cbMotherNaturalParent' className='add-only' value='NaturalParent' /> Natural parent<br /></td>
                        <td className='w-187'><input type='checkbox' name='cbMotherStepParent' id='cbMotherStepParent' className='add-only' value='StepParent' /> Step-parent</td>
                        <td className='w-187'><input type='checkbox' name='cbMotherAdoptiveParent' id='cbMotherAdoptiveParent' className='add-only' value='AdoptiveParent' /> Adoptive parent</td>
                        <td className='w-187'><input type='checkbox' name='cbMotherFosterHome' id='cbMotherFosterHome' className='add-only' value='FosterHome' /> Foster home</td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbLivingOther' id='cbLivingOther' className='add-only' value='LivingOther' /> Other:&nbsp;

                            <input type='text' id='txtLivingOther' name='txtLivingOther' className='add-only w-250 custom-add-only' /></td>

                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Is their anything notable, unusual or stressful about the child&#39;s relationship with the mother?</span>
                </p>
                <table>
                    <tr>
                        <td ><input type='radio' id='rbRelationshipWithMotherYes' name='rbRelationshipWithMother' className='add-only' value='RelationshipWithMotherYes' /> Yes &nbsp;
                            <input type='radio' id='rbRelationshipWithMotherno' name='rbRelationshipWithMother' className='add-only' value='RelationshipWithMotherNo' /> No</td>
                    </tr>

                    <tr>
                        <td className='w-750'> If yes, please explain:

                            <input type='text' id='txtPleaseExplain' name='txtPleaseExplain' className='add-only' /></td>

                    </tr><br />
                </table>
                <p className='w-750'><h3><b>Client&#39;s Father</b></h3></p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'> Name:</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'> Age:</span>
                        </td>
                        <td className='w-450'>
                            <span className='eleHeader'> Occupation:</span>
                        </td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtFatherName' name='txtFatherName' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtFatherAge' name='txtFatherAge' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtFatherOccupation' name='txtFatherOccupation' className='add-only w-350 custom-add-only' />&nbsp;
                            </td>
                            <td className='w-100'>
                            <input type='radio' id='rbFatherOccupationFt' name='rbFatherOccupation' className='add-only' value='Ft' /> FT &nbsp;
                            <input type='radio' id='rbFatherOccupationPt' name='rbFatherOccupation' className='add-only' value='Pt' /> PT
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'> Where employed:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'> Work phone:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtFatherEmployed' name='txtFatherEmployed' className='add-only w-365 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtFatherWorkPhone' name='txtFatherWorkPhone' className='add-only w-365 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'> Father&#39;s education:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtFatherEducation' name='txtFatherEducation' className='add-only w-365 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Is the child currently living with father?</span>
                </p>
                <table>
                    <tr>
                        <td><input type='radio' id='rbLivingWithFatherYes' name='rbLivingWithFather' className='add-only' value='LivingWithFatherYes' /> Yes &nbsp;
                            <input type='radio' id='rbLivingWithFatherno' name='rbLivingWithFather' className='add-only' value='LivingWithFatherNo' /> No
                        </td>
                    </tr>



                    <tr>
                        <td className='w-187'><input type='checkbox' name='cbFatherNaturalParent' id='cbcbFatherNaturalParent' className='add-only' value='NaturalParent' /> Natural parent<br /></td>
                        <td className='w-187'><input type='checkbox' name='cbFatherStepParent' id='cbcbFatherStepParent' className='add-only' value='StepParent' /> Step-parent</td>
                        <td className='w-187'><input type='checkbox' name='cbFatherAdoptiveParent' id='cbcbFatherAdoptiveParent' className='add-only' value='AdoptiveParent' /> Adoptive parent</td>
                        <td className='w-187'><input type='checkbox' name='cbFatherFosterHome' id='cbcbFatherFosterHome' className='add-only' value='FosterHome' /> Foster home</td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbPrimary20' id='cbPrimary20' className='add-only' value='Other Mental Health' /> Other:&nbsp;

                            <input type='text' id='txtOtherMental' name='txtOtherMental' className='add-only w-250 custom-add-only' /></td>

                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Is their anything notable, unusual or stressful about the child&#39;s relationship with the father?</span>
                </p>
                <table>
                    <tr>
                        <td ><input type='radio' id='rbRelationshipWithFatherYes' name='rbRelationshipWithFather' className='add-only' value='RelationshipWithFatherYes' /> Yes &nbsp;
                            <input type='radio' id='rbRelationshipWithFatherno' name='rbRelationshipWithFather' className='add-only' value='RelationshipWithFatherNo' /> No</td>
                    </tr>

                    <tr>
                        <td className='w-750'> If yes, please explain:

                            <input type='text' id='txtRelationshipWithFatherExplain' name='txtRelationshipWithFatherExplain' className='add-only' /></td>

                    </tr><br />
                </table>

                <p className='w-750'><h3><b> Client&#39;s Siblings and Others Who Live in the Household</b></h3></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Client's siblings who live in the household:</span>
                        </td>

                    </tr>
                    <tr>
                        <td className='w-200'>
                            <span className='eleHeader'> Names of Siblings</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'> Age</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'> Gender</span>
                        </td>
                        <td className='w-120'>
                            <span className='eleHeader'> Lives</span>
                        </td>
                        <td className='w-280'>
                            <span className='eleHeader'> Quality of relationship with the client</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id='txtNameOfSibling_1' name='txtNameOfSibling_1' className='add-only' /></td>
                        <td className='w-50'><input type='text' id='txtAgeOfSibling_1' name='txtNameOfSibling_1' className='add-only' /></td>
                        <td className='w-100'><center><input type='radio' id='rbGenderSiblingF_1' name='rbGenderSibling_1' className='add-only' value='F_1' /> F &nbsp;
                            <input type='radio' id='rbGenderSiblingM_1' name='rbGenderSibling_1' className='add-only' value='M_1' /> M
                        </center>
                        </td>
                        <td className='w-120'><center><input type='radio' id='rbLivesSiblingHome_1' name='rbLivesSibling_1' className='add-only' value='Home_1' /> home &nbsp;
                            <input type='radio' id='rbLivesSiblingAway_1' name='rbLivesSibling_1' className='add-only' value='Away_1' /> away
                        </center>
                        </td>
                        <td className='w-280'><center>
                            <input type='radio' id='rRelationshipWithSiblingPoor_1' name='rRelationshipWithSibling_1' className='add-only' value='Poor_1' /> poor &nbsp;
                            <input type='radio' id='rRelationshipWithSiblingAverage_1' name='rRelationshipWithSibling_1' className='add-only' value='Average_1' /> average &nbsp;
                            <input type='radio' id='rRelationshipWithSiblingGood_1' name='rRelationshipWithSibling_1' className='add-only' value='Good_1' /> good
                        </center></td>

                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id='txtNameOfSibling_2' name='txtNameOfSibling_2' className='add-only' /></td>
                        <td className='w-50'><input type='text' id='txtAgeOfSibling_2' name='txtNameOfSibling_2' className='add-only' /></td>
                        <td className='w-100'><center><input type='radio' id='rbGenderSiblingF_2' name='rbGenderSibling_2' className='add-only' value='F_2' /> F &nbsp;
                            <input type='radio' id='rbGenderSiblingM_2' name='rbGenderSibling_2' className='add-only' value='M_2' /> M
                        </center>
                        </td>
                        <td className='w-120'><center><input type='radio' id='rbLivesSiblingHome_2' name='rbLivesSibling_2' className='add-only' value='Home_2' /> home &nbsp;
                            <input type='radio' id='rbLivesSiblingAway_2' name='rbLivesSibling_2' className='add-only' value='Away_2' /> away
                        </center>
                        </td>
                        <td className='w-280'><center>
                            <input type='radio' id='rRelationshipWithSiblingPoor_2' name='rRelationshipWithSibling_2' className='add-only' value='Poor_2' /> poor &nbsp;
                            <input type='radio' id='rRelationshipWithSiblingAverage_2' name='rRelationshipWithSibling_2' className='add-only' value='Average_2' /> average &nbsp;
                            <input type='radio' id='rRelationshipWithSiblingGood_2' name='rRelationshipWithSibling_2' className='add-only' value='Good_2' /> good
                        </center></td>

                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id='txtNameOfSibling_3' name='txtNameOfSibling_3' className='add-only' /></td>
                        <td className='w-50'><input type='text' id='txtAgeOfSibling_3' name='txtNameOfSibling_3' className='add-only' /></td>
                        <td className='w-100'><center><input type='radio' id='rbGenderSiblingF_3' name='rbGenderSibling_3' className='add-only' value='F_3' /> F &nbsp;
                            <input type='radio' id='rbGenderSiblingM_3' name='rbGenderSibling_3' className='add-only' value='M_3' /> M
                        </center>
                        </td>
                        <td className='w-120'><center><input type='radio' id='rbLivesSiblingHome_3' name='rbLivesSibling_3' className='add-only' value='Home_3' /> home &nbsp;
                            <input type='radio' id='rbLivesSiblingAway_3' name='rbLivesSibling_3' className='add-only' value='Away_3' /> away
                        </center>
                        </td>
                        <td className='w-280'><center>
                            <input type='radio' id='rRelationshipWithSiblingPoor_3' name='rRelationshipWithSibling_3' className='add-only' value='Poor_3' /> poor &nbsp;
                            <input type='radio' id='rRelationshipWithSiblingAverage_3' name='rRelationshipWithSibling_3' className='add-only' value='Average_3' /> average &nbsp;
                            <input type='radio' id='rRelationshipWithSiblingGood_3' name='rRelationshipWithSibling_3' className='add-only' value='Good_3' /> good
                        </center></td>

                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id='txtNameOfSibling_4' name='txtNameOfSibling_4' className='add-only' /></td>
                        <td className='w-50'><input type='text' id='txtAgeOfSibling_4' name='txtNameOfSibling_4' className='add-only' /></td>
                        <td className='w-100'><center><input type='radio' id='rbGenderSiblingF_4' name='rbGenderSibling_4' className='add-only' value='F_4' /> F &nbsp;
                            <input type='radio' id='rbGenderSiblingM_4' name='rbGenderSibling_4' className='add-only' value='M_4' /> M
                        </center>
                        </td>
                        <td className='w-120'><center><input type='radio' id='rbLivesSiblingHome_4' name='rbLivesSibling_4' className='add-only' value='Home_4' /> home &nbsp;
                            <input type='radio' id='rbLivesSiblingAway_4' name='rbLivesSibling_4' className='add-only' value='Away_4' /> away
                        </center>
                        </td>
                        <td className='w-280'><center>
                            <input type='radio' id='rRelationshipWithSiblingPoor_4' name='rRelationshipWithSibling_4' className='add-only' value='Poor_4' /> poor &nbsp;
                            <input type='radio' id='rRelationshipWithSiblingAverage_4' name='rRelationshipWithSibling_4' className='add-only' value='Average_4' /> average &nbsp;
                            <input type='radio' id='rRelationshipWithSiblingGood_4' name='rRelationshipWithSibling_4' className='add-only' value='Good_4' /> good
                        </center></td>

                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id='txtNameOfSibling_5' name='txtNameOfSibling_5' className='add-only' /></td>
                        <td className='w-50'><input type='text' id='txtAgeOfSibling_5' name='txtNameOfSibling_5' className='add-only' /></td>
                        <td className='w-100'><center><input type='radio' id='rbGenderSiblingF_5' name='rbGenderSibling_5' className='add-only' value='F_5' /> F &nbsp;
                            <input type='radio' id='rbGenderSiblingM_5' name='rbGenderSibling_5' className='add-only' value='M_5' /> M
                        </center>
                        </td>
                        <td className='w-120'><center><input type='radio' id='rbLivesSiblingHome_5' name='rbLivesSibling_5' className='add-only' value='Home_5' /> home &nbsp;
                            <input type='radio' id='rbLivesSiblingAway_5' name='rbLivesSibling_5' className='add-only' value='Away_5' /> away
                        </center>
                        </td>
                        <td className='w-280'><center>
                            <input type='radio' id='rRelationshipWithSiblingPoor_5' name='rRelationshipWithSibling_5' className='add-only' value='Poor_5' /> poor &nbsp;
                            <input type='radio' id='rRelationshipWithSiblingAverage_5' name='rRelationshipWithSibling_5' className='add-only' value='Average_5' /> average &nbsp;
                            <input type='radio' id='rRelationshipWithSiblingGood_5' name='rRelationshipWithSibling_5' className='add-only' value='Good_5' /> good
                        </center></td>

                    </tr>


                </table>
                <table>

                    <tr>
                        <td className='w-200'>
                            <span className='eleHeader'> Others living in the househousehold</span>
                        </td>
                        <td className='w-550'><center>
                            <span className='eleHeader'> Relationship<span className='small'>(e.g., cousin, foster child)</span></span></center>
                        </td>

                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id='RelationOfSibling_1' name='RelationOfSibling_1' className='add-only' /></td>
                        <td className='w-50'><input type='text' id='RelationOfSibling_1' name='RelationOfSibling_1' className='add-only' /></td>
                        <td className='w-100'><center><input type='radio' id='rbGenderOfSiblingF_1' name='rbGenderOfSibling_1' className='add-only' value='SiblingF_1' /> F &nbsp;
                            <input type='radio' id='rbGenderOfSiblingM_1' name='rbGenderOfSibling_1' className='add-only' value='SiblingM_1' /> M
                        </center>
                        </td>
                        <td className='w-120'><center><input type='radio' id='rbSiblingLivesHome_1' name='rbSiblingLives_1' className='add-only' value='SiblingHome_1' /> home &nbsp;
                            <input type='radio' id='rbSiblingLivesAway_1' name='rbSiblingLives_1' className='add-only' value='SiblingAway_1' /> away
                        </center>
                        </td>
                        <td className='w-280'><center>
                            <input type='radio' id='rbSiblingsRelationPoor_1' name='rbSiblingsRelation_1' className='add-only' value='SiblingPoor_1' /> poor &nbsp;
                            <input type='radio' id='rbSiblingsRelationAverage_1' name='rbSiblingsRelation_1' className='add-only' value='SiblingAverage_1' /> average &nbsp;
                            <input type='radio' id='rbSiblingsRelationGood_1' name='rbSiblingsRelation_1' className='add-only' value='SiblingGood_1' /> good
                        </center></td>

                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id='RelationOfSibling_1' name='RelationOfSibling_1' className='add-only' /></td>
                        <td className='w-50'><input type='text' id='RelationOfSibling_1' name='RelationOfSibling_1' className='add-only' /></td>
                        <td className='w-100'><center><input type='radio' id='rbGenderOfSiblingF_2' name='rbGenderOfSibling_2' className='add-only' value='SiblingF_2' /> F &nbsp;
                            <input type='radio' id='rbGenderOfSiblingM_2' name='rbGenderOfSibling_2' className='add-only' value='SiblingM_2' /> M
                        </center>
                        </td>
                        <td className='w-120'><center><input type='radio' id='rbSiblingLivesHome_2' name='rbSiblingLives_2' className='add-only' value='SiblingHome_2' /> home &nbsp;
                            <input type='radio' id='rbSiblingLivesAway_2' name='rbSiblingLives_2' className='add-only' value='SiblingAway_2' /> away
                        </center>
                        </td>
                        <td className='w-280'><center>
                            <input type='radio' id='rbSiblingsRelationPoor_2' name='rbSiblingsRelation_2' className='add-only' value='SiblingPoor_2' /> poor &nbsp;
                            <input type='radio' id='rbSiblingsRelationAverage_2' name='rbSiblingsRelation_2' className='add-only' value='SiblingAverage_2' /> average &nbsp;
                            <input type='radio' id='rbSiblingsRelationGood_2' name='rbSiblingsRelation_2' className='add-only' value='SiblingGood_2' /> good
                        </center></td>

                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id='rbRelationOfSibling_1' name='rbRelationOfSibling_1' className='add-only' /></td>
                        <td className='w-50'><input type='text' id='rbRelationOfSibling_1' name='rbRelationOfSibling_1' className='add-only' /></td>
                        <td className='w-100'><center><input type='radio' id='rbGenderOfSiblingF_3' name='rbGenderOfSibling_3' className='add-only' value='SiblingF_3' /> F &nbsp;
                            <input type='radio' id='rbGenderOfSiblingM_3' name='rbGenderOfSibling_3' className='add-only' value='SiblingM_3' /> M
                        </center>
                        </td>
                        <td className='w-120'><center><input type='radio' id='rbSiblingLivesHome_3' name='rbSiblingLives_3' className='add-only' value='SiblingHome_3' /> home &nbsp;
                            <input type='radio' id='rbSiblingLivesAway_3' name='rbSiblingLives_3' className='add-only' value='SiblingAway_3' /> away
                        </center>
                        </td>
                        <td className='w-280'><center>
                            <input type='radio' id='rbSiblingsRelationPoor_3' name='rbSiblingsRelation_3' className='add-only' value='SiblingPoor_3' /> poor &nbsp;
                            <input type='radio' id='rbSiblingsRelationAverage_3' name='rbSiblingsRelation_3' className='add-only' value='SiblingAverage_3' /> average &nbsp;
                            <input type='radio' id='rbSiblingsRelationGood_3' name='rbSiblingsRelation_3' className='add-only' value='SiblingGood_3' /> good
                        </center></td>

                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id='rbRelationOfSibling_1' name='rbRelationOfSibling_1' className='add-only' /></td>
                        <td className='w-50'><input type='text' id='rbRelationOfSibling_1' name='rbRelationOfSibling_1' className='add-only' /></td>
                        <td className='w-100'><center><input type='radio' id='rbGenderOfSiblingF_4' name='rbGenderOfSibling_4' className='add-only' value='SiblingF_4' /> F &nbsp;
                            <input type='radio' id='rbGenderOfSiblingM_4' name='rbGenderOfSibling_4' className='add-only' value='SiblingM_4' /> M
                        </center>
                        </td>
                        <td className='w-120'><center><input type='radio' id='rbSiblingLivesHome_4' name='rbSiblingLives_4' className='add-only' value='SiblingHome_4' /> home &nbsp;
                            <input type='radio' id='rbSiblingLivesAway_4' name='rbSiblingLives_4' className='add-only' value='SiblingAway_4' /> away
                        </center>
                        </td>
                        <td className='w-280'><center>
                            <input type='radio' id='rbSiblingsRelationPoor_4' name='rbSiblingsRelation_4' className='add-only' value='SiblingPoor_4' /> poor &nbsp;
                            <input type='radio' id='rbSiblingsRelationAverage_4' name='rbSiblingsRelation_4' className='add-only' value='SiblingAverage_4' /> average &nbsp;
                            <input type='radio' id='rbSiblingsRelationGood_4' name='rbSiblingsRelation_4' className='add-only' value='SiblingGood_4' /> good
                        </center></td>

                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'> Comments:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='rbRelationOfSibling_1' name='rbRelationOfSibling_1' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><center><h3> Family Health History</h3></center></p>
                <p className='w-750'> Have any of the following diseases occurred among the child&#39;s blood relatives?
                    <span className='small'>(parents, siblings, aunts, uncles or grandparents) Check those that apply:</span></p>

                <table>
                    <tr>
                        <td className='w-187'><input type='checkbox' name='cbAllergies' id='cbAllergies' className='add-only' value='Allergies' /> Allergies</td>
                        <td className='w-187'><input type='checkbox' name='cbAnemia' id='cbAnemia' className='add-only' value='Anemia' /> Anemia</td>
                        <td className='w-187'><input type='checkbox' name='cbAsthma' id='cbAsthma' className='add-only' value='Asthma' /> Asthma</td>
                        <td className='w-187'><input type='checkbox' name='cbBleedingTendency' id='cbBleedingTendency' className='add-only' value='BleedingTendency' /> Bleeding tendency</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' name='cbBlindness' id='cbBlindness' className='add-only' value='Blindness' /> Blindness</td>
                        <td className='w-187'><input type='checkbox' name='cbCancer' id='cbCancer' className='add-only' value='Cancer' /> Cancer</td>
                        <td className='w-187'><input type='checkbox' name='cbCerebralPaisy' id='cbCerebralPaisy' className='add-only' value='CerebralPaisy' /> Cerebral Paisy</td>
                        <td className='w-187'><input type='checkbox' name='cbCleftLips' id='cbCleftLips' className='add-only' value='CleftLips' /> Cleft lips</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' name='cbCleftPalate' id='cbCleftPalate' className='add-only' value='CleftPalate' /> Cleft palate</td>
                        <td className='w-187'><input type='checkbox' name='cbDeafness' id='cbDeafness' className='add-only' value='Deafness' /> Deafness</td>
                        <td className='w-187'><input type='checkbox' name='cbDiabetes' id='cbDiabetes' className='add-only' value='Diabetes' /> Diabetes</td>
                        <td className='w-187'><input type='checkbox' name='cbGlandularProblems' id='cbGlandularProblems' className='add-only' value='GlandularProblems' /> Glandular problems</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' name='cbHeartDiseases' id='cbHeartDiseases' className='add-only' value='HeartDiseases' /> Heart diseases</td>
                        <td className='w-187'><input type='checkbox' name='cbHighBloodPressure' id='cbHighBloodPressure' className='add-only' value='HighBloodPressure' /> High blood pressure</td>
                        <td className='w-187'><input type='checkbox' name='cbKidneyDiseases' id='cbKidneyDiseases' className='add-only' value='KidneyDiseases' /> Kidney diseases</td>
                        <td className='w-187'><input type='checkbox' name='cbMentalIllness' id='cbMentalIllness' className='add-only' value='MentalIllness' /> Mental illness</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' name='cbMigraines' id='cbMigraines' className='add-only' value='Migraines' /> Migraines</td>
                        <td className='w-187'><input type='checkbox' name='cbMultipleSclerosis' id='cbMultipleSclerosis' className='add-only' value='MultipleSclerosis' /> Multiple sclerosis</td>
                        <td className='w-187'><input type='checkbox' name='cbMuscularDystrophy' id='cbMuscularDystrophy' className='add-only' value='MuscularDystrophy' /> Muscular Dystrophy</td>
                        <td className='w-187'><input type='checkbox' name='cbNervousness' id='cbNervousness' className='add-only' value='Nervousness' /> Nervousness</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' name='cbMentalRetardation' id='cbMentalRetardation' className='add-only' value='MentalRetardation' /> Mental Retardation</td>
                        <td className='w-187'><input type='checkbox' name='cbSeizures' id='cbSeizures' className='add-only' value='Seizures' /> Seizures</td>
                        <td className='w-187'><input type='checkbox' name='cbSpinalBifida' id='cbSpinalBifida' className='add-only' value='SpinalBifida' /> Spinal Bifida</td>
                        <td className='w-187'><input type='checkbox' name='cbSuicide' id='cbSuicide' className='add-only' value='Suicide' /> Suicide</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' name='cbPerceptualMotorDisorder' id='cbPerceptualMotorDisorder' className='add-only' value='PerceptualMotorDisorder' /> Perceptual motor disorder</td>


                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbHealthHistoryOther' id='cbHealthHistoryOther' className='add-only' value='HealthHistoryOther' /> Other (specify):
                            <input type='text' name='txtHealthHistoryOther' id='txtHealthHistoryOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>Comments re: Family Health:</td>
                    </tr>

                    <tr>
                        <td className='w-750'><textarea name='txtFamilyHealth' id='txtFamilyHealth' className='add-only' ></textarea></td>
                    </tr>
                </table>

                <p className='w-750'><center><h3> Education</h3></center></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'> Current School:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'> School phone number:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtCurrentSchool' name='txtCurrentSchool' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtSchoolPhoneNumber' name='txtSchoolPhoneNumber' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'> Type of school:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' name='cbPublic' id='cbPublic' className='add-only' value='Public' /> Public</td>
                        <td className='w-250'><input type='checkbox' name='cbPrivate' id='cbPrivate' className='add-only' value='Private' /> Private</td>
                        <td className='w-250'><input type='checkbox' name='cbHomeSchooled' id='cbHomeSchooled' className='add-only' value='HomeSchooled' /> Home schooled</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' name='cbSchoolOther' id='cbSchoolOther' className='add-only' value='SchoolOther' /> Other(specify):&nbsp;
                            <input type='text' name='txtSchoolOther' id='txtSchoolOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'> Grade:</span>
                        </td>
                        <td className='w-300'>
                            <span className='eleHeader'> Teacher:</span>
                        </td>
                        <td className='w-300'>
                            <span className='eleHeader'> School Counselor:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtGrade' name='txtGrade' className='add-only' />
                        </td>
                        <td className='w-300'>
                            <input type='text' id='txtTeacher' name='txtTeacher' className='add-only' />
                        </td>
                        <td className='w-300'>
                            <input type='text' id='txtSchoolCounselor' name='txtSchoolCounselor' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'> In special education?</span></td>
                    </tr>
                    <tr>
                        <td ><input type='radio' id='rbSpecialEducationYes' name='rbSpecialEducation' className='add-only' value='SpecialEducationYes' /> Yes &nbsp;
                            <input type='radio' id='rbSpecialEducationNo' name='rbSpecialEducation' className='add-only' value='SpecialEducationNo' /> No</td>
                    </tr>

                    <tr>
                        <td className='w-750'>If Yes, describe:
                            <input type='text' name='txtSpecialEducationDescribe' id='txtSpecialEducationDescribe' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>In gifted program?</span></td>
                    </tr>
                    <tr>
                        <td ><input type='radio' id='rbGiftedProgramYes' name='rbGiftedProgram' className='add-only' value='GiftedProgramYes' /> Yes &nbsp;
                            <input type='radio' id='rbGiftedProgramNo' name='rbGiftedProgram' className='add-only' value='GiftedProgramNo' /> No</td>
                    </tr>
                    <tr>
                        <td className='w-750'>If Yes, describe:
                            <input type='text' name='txtSpecialEducation' id='txtSpecialEducation' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Has child ever been held back in school?</span></td>
                    </tr>
                    <tr>
                        <td ><input type='radio' id='rbRelationshipWithFatherYes' name='rbRelationshipWithFather' className='add-only' value='RelationshipWithFatherYes' /> Yes &nbsp;
                            <input type='radio' id='rbRelationshipWithFatherno' name='rbRelationshipWithFather' className='add-only' value='RelationshipWithFatherNo' /> No</td>
                    </tr>

                    <tr>
                        <td className='w-750'>If Yes, describe:
                            <input type='text' name='txtGiftedProgram' id='txtGiftedProgram' className='add-only w-350 custom-add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'> Which subjects does the child enjoy in school?</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'> Which subjects does the child dislike in school?</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtSubjectChildEnjoy' name='txtSubjectChildEnjoy' className='add-only w-365 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtSubjectChildDislike' name='txtSubjectChildDislike' className='add-only w-365 custom-add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-375'><span className='eleHeader'> What grades the child usually receive in school?</span></td>
                        <td className='w-375'><span className='eleHeader'> Have been there any recent changes in the child&#39;s grades?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' name='txtGradeReceiveInSchool' id='txtGradeReceiveInSchool' className='add-only' /></td>
                        <td className='w-375'><input type='radio' id='rbChangesInGradesYes' name='rbChangesInGrades' className='add-only' value='ChangesInGradesYes' /> Yes &nbsp;
                            <input type='radio' id='rbChangesInGradesNo' name='rbChangesInGrades' className='add-only' value='ChangesInGradesNo' /> No</td>
                    </tr>

                    <tr>
                        <td className='w-750'>If Yes, describe:
                            <input type='text' name='txtChangesInGradesDescribe' id='txtChangesInGradesDescribe' className='add-only w-350 custom-add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'> Has the child been tested psychologically?</span></td>
                    </tr>
                    <tr>
                        <td ><input type='radio' id='rbChildTestedPsychologicallyYes' name='rbChildTestedPsychologically' className='add-only' value='ChildTestedPsychologicallyYes' /> Yes &nbsp;
                            <input type='radio' id='rbChildTestedPsychologicallyNo' name='rbChildTestedPsychologically' className='add-only' value='ChildTestedPsychologicallyNo' /> No</td>
                    </tr>

                    <tr>
                        <td className='w-750'> If Yes, describe:
                            <input type='text' name='txtSpecialEducation' id='txtSpecialEducation' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                    
                </table>


                <p className='w-750'><h3> Check the descriptions, which specifically realate to your child.</h3></p>

                <p className='w-750'><span className='eleHeader'> Feelings about School Work:</span></p>

                <table>
                    <tr>
                        <td className='w-187'><input type='checkbox' name='cbAnxious' id='cbAnxious' className='add-only' value='Anxious' /> Anxious</td>
                        <td className='w-187'><input type='checkbox' name='cbPassive' id='cbPassive' className='add-only' value='Passive' /> Passive</td>
                        <td className='w-187'><input type='checkbox' name='cbEnthusiastic' id='cbEnthusiastic' className='add-only' value='Enthusiastic' /> Enthusiastic</td>
                        <td className='w-187'><input type='checkbox' name='cbFearful' id='cbFearful' className='add-only' value='Fearful' /> Fearful</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' name='cbEager' id='cbEager' className='add-only' value='Eager' /> Eager</td>
                        <td className='w-187'><input type='checkbox' name='cbNoExpression' id='cbNoExpression' className='add-only' value='NoExpression' /> No expression</td>
                        <td className='w-187'><input type='checkbox' name='cbBored' id='cbBored' className='add-only' value='Bored' /> Bored</td>
                        <td className='w-187'><input type='checkbox' name='cbRebellious' id='cbRebellious' className='add-only' value='Rebellious' /> Rebellious</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='cbFeelingSchoolWorkOther' id='cbFeelingSchoolWorkOther' className='add-only' value='Other' /> Other(describe):&nbsp;
                            <input type='text' name='txtFeelingSchoolWorkOther' id='txtFeelingSchoolWorkOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'> Approach to School Work:</span></p>

                <table>
                    <tr>
                        <td className='w-187'><input type='checkbox' name='cbOrganised' id='cbOrganised' className='add-only' value='Organised' /> Organised</td>
                        <td className='w-187'><input type='checkbox' name='cbIndustrious' id='cbIndustrious' className='add-only' value='Industrious' /> Industrious</td>
                        <td className='w-187'><input type='checkbox' name='cbResponsible' id='cbResponsible' className='add-only' value='Responsible' /> Responsible</td>
                        <td className='w-187'><input type='checkbox' name='cbIntrested' id='cbIntrested' className='add-only' value='Intrested' /> Intrested</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' name='cbSelfDirected' id='cbSelfDirected' className='add-only' value='SelfDirected' /> Self-directed</td>
                        <td className='w-187'><input type='checkbox' name='cbNoInitiative' id='cbNoInitiative' className='add-only' value='NoInitiative' /> No initiative</td>
                        <td className='w-187'><input type='checkbox' name='cbRefuses' id='cbRefuses' className='add-only' value='Refuses' /> Refuses</td>
                        <td className='w-187'><input type='checkbox' name='cbSloppy' id='cbSloppy' className='add-only' value='Sloppy' /> Sloppy</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' name='cbDisorganized' id='cbDisorganized' className='add-only' value='Disorganized' /> Disorganized</td>
                        <td className='w-187'><input type='checkbox' name='cbCooperative' id='cbCooperative' className='add-only' value='Cooperative' /> Cooperative</td>
                        <td className='w-375'><input type='checkbox' name='cbDoesOnlyWhatExpected' id='cbDoesOnlyWhatExpected' className='add-only' value='DoesOnlyWhatExpected' /> Does only what is expected</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' name='cbDoesnotCompleteAssignments' id='cbDoesnotCompleteAssignments' className='add-only' value='DoesnotCompleteAssignments' /> Doesn&#39;t complete assignments</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='cbApproachSchoolWorkOther' id='cbApproachSchoolWorkOther' className='add-only' value='ApproachSchoolWorkOther' /> Other(describe):&nbsp;
                            <input type='text' name='txtApproachSchoolWorkOther' id='txtApproachSchoolWorkOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'> Performance in School (Parent&#39;s Opinion):</span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' name='cbSatisfactory' id='cbSatisfactory' className='add-only' value='Satisfactory' /> Satisfactory</td>
                        <td className='w-250'><input type='checkbox' name='cbUnderachiever' id='cbUnderachiever' className='add-only' value='Underachiever' /> Underachiever</td>
                        <td className='w-250'><input type='checkbox' name='cbOverachiever' id='cbOverachiever' className='add-only' value='Overachiever' /> Overachiever</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='cbPerformanceInSchoolOther' id='cbPerformanceInSchoolOther' className='add-only' value='PerformanceInSchoolOther' /> Other(describe):&nbsp;
                            <input type='text' name='txtPerformanceInSchoolOther' id='txtPerformanceInSchoolOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Child&#39;s Peer Relationship:</span></p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' name='cbSpontaneous' id='cbSpontaneous' className='add-only' value='Spontaneous' /> Spontaneous</td>
                        <td className='w-250'><input type='checkbox' name='cbFollower' id='cbFollower' className='add-only' value='Follower' /> Follower</td>
                        <td className='w-250'><input type='checkbox' name='cbLeader' id='cbLeader' className='add-only' value='Leader' /> Leader</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' name='cbSharesEasily' id='cbSharesEasily' className='add-only' value='SharesEasily' /> SharesEasily</td>
                        <td className='w-250'><input type='checkbox' name='cbLongTimeFriends' id='cbLongTimeFriends' className='add-only' value='LongTimeFriends' /> LongTimeFriends</td>
                        <td className='w-250'><input type='checkbox' name='cbMakesFriendsEasily' id='cbMakesFriendsEasily' className='add-only' value='MakesFriendsEasily' /> MakesFriendsEasily</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' name='cbDifficultyMakingFriends' id='cbDifficultyMakingFriends' className='add-only' value='DifficultyMakingFriends' /> DifficultyMakingFriends</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='cbChildPeerRelationshipOther' id='cbChildPeerRelationshipOther' className='add-only' value='ChildPeerRelationshipOther' /> Other(describe):&nbsp;
                            <input type='text' name='txtChildPeerRelationshipOther' id='txtChildPeerRelationshipOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>What is the child&#39;s attitude toward work?</span></p>

                <table>
                    <tr>
                        <td className='w-187'><input type='checkbox' name='cbPoor' id='cbPoor' className='add-only' value='Poor' /> Poor</td>
                        <td className='w-187'><input type='checkbox' name='cbAverage' id='cbAverage' className='add-only' value='Average' /> Average</td>
                        <td className='w-187'><input type='checkbox' name='cbGood' id='cbGood' className='add-only' value='Good' /> Good</td>
                        <td className='w-187'><input type='checkbox' name='cbExcellent' id='cbExcellent' className='add-only' value='Excellent' /> Excellent</td>
                    </tr>

                    <tr>
                        <td className='w-300'>
                            <span className='eleHeader'> Current employer:</span>
                        </td>
                        <td className='w-300'>
                            <span className='eleHeader'> Position:</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'> Hours per week:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type='text' id='txtCurrentEmployer' name='txtCurrentEmployer' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtPosition' name='txtPosition' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtHoursOfWorks' name='txtHoursOfWorks' className='add-only' /></td>
                    </tr>

                </table>
                <p className='w-750'><center><h3> Most recent examinations:</h3></center></p>

                <table>
                    <tr>
                        <td className='w-180'><span className='eleHeader'> Type of examinations</span></td>
                        <td className='w-160'><span className='eleHeader'> Date of most recent visit</span></td>
                        <td className='w-410'><span className='eleHeader'> Results</span></td>
                    </tr>

                    <tr>
                        <td className='w-180'> Physical examination</td>
                        <td className='w-160'><input type='date' name='txtPhysicalExaminationDate' id='txtPhysicalExaminationDate' className='add-only' /></td>
                        <td className='w-410'><input type='text' name='txtPhysicalExaminationResult' id='txtPhysicalExaminationResult' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-180'> Dental examination</td>
                        <td className='w-160'><input type='date' name='txtDentalExaminationDate' id='txtDentalExaminationDate' className='add-only' /></td>
                        <td className='w-410'><input type='text' name='txtDentalExaminationResult' id='txtDentalExaminationResult' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-180'> Vision examination</td>
                        <td className='w-160'><input type='date' name='txtVisionExaminationDate' id='txtVisionExaminationDate' className='add-only' /></td>
                        <td className='w-410'><input type='text' name='txtVisionExaminationResult' id='txtVisionExaminationResult' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-180'> Vision examination</td>
                        <td className='w-160'><input type='date' name='txtVisionExaminationDate' id='txtVisionExaminationDate' className='add-only' /></td>
                        <td className='w-410'><input type='text' name='txtVisionExaminationResult' id='txtVisionExaminationResult' className='add-only' /></td>
                    </tr>

                </table>
                <p className='w-750'><center><h3> Medication</h3></center></p>

                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'> Current prescribed medications</span></td>
                        <td className='w-50'><span className='eleHeader'> Dose</span></td>
                        <td className='w-150'><span className='eleHeader'> Dates</span></td>
                        <td className='w-200'><span className='eleHeader'> Purpose</span></td>
                        <td className='w-200'><span className='eleHeader'> Side effects</span></td>
                    </tr>

                    <tr>
                        <td className='w-150'><input type='text' name='txtMedicationCurrentPrescribed_1' id='txtMedicationCurrentPrescribed_1' className='add-only' /></td>
                        <td className='w-50'><input type='text' name='txtMedicationDose_1' id='txtMedicationDose_1' className='add-only' /></td>
                        <td className='w-150'><input type='date' name='txtMedicationDate_1' id='txtMedicationDate_1' className='add-only' /></td>
                        <td className='w-200'><input type='text' name='txtMedicationPurpose_1' id='txtMedicationPurpose_1' className='add-only' /></td>
                        <td className='w-200'><input type='text' name='txtMedicationSideEffects_1' id='txtMedicationSideEffects_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' name='txtMedicationCurrentPrescribed_2' id='txtMedicationCurrentPrescribed_2' className='add-only' /></td>
                        <td className='w-50'><input type='text' name='txtMedicationDose_2' id='txtMedicationDose_2' className='add-only' /></td>
                        <td className='w-150'><input type='date' name='txtMedicationDate_2' id='txtMedicationDate_2' className='add-only' /></td>
                        <td className='w-200'><input type='text' name='txtMedicationPurpose_2' id='txtMedicationPurpose_2' className='add-only' /></td>
                        <td className='w-200'><input type='text' name='txtMedicationSideEffects_2' id='txtMedicationSideEffects_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' name='txtMedicationCurrentPrescribed_3' id='txtMedicationCurrentPrescribed_3' className='add-only' /></td>
                        <td className='w-50'><input type='text' name='txtMedicationDose_3' id='txtMedicationDose_3' className='add-only' /></td>
                        <td className='w-150'><input type='date' name='txtMedicationDate_3' id='txtMedicationDate_3' className='add-only' /></td>
                        <td className='w-200'><input type='text' name='txtMedicationPurpose_3' id='txtMedicationPurpose_3' className='add-only' /></td>
                        <td className='w-200'><input type='text' name='txtMedicationSideEffects_3' id='txtMedicationSideEffects_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' name='txtMedicationCurrentPrescribed_4' id='txtMedicationCurrentPrescribed_4' className='add-only' /></td>
                        <td className='w-50'><input type='text' name='txtMedicationDose_4' id='txtMedicationDose_4' className='add-only' /></td>
                        <td className='w-150'><input type='date' name='txtMedicationDate_4' id='txtMedicationDate_4' className='add-only' /></td>
                        <td className='w-200'><input type='text' name='txtMedicationPurpose_4' id='txtMedicationPurpose_4' className='add-only' /></td>
                        <td className='w-200'><input type='text' name='txtMedicationSideEffects_4' id='txtMedicationSideEffects_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' name='txtMedicationCurrentPrescribed_5' id='txtMedicationCurrentPrescribed_5' className='add-only' /></td>
                        <td className='w-50'><input type='text' name='txtMedicationDose_5' id='txtMedicationDose_5' className='add-only' /></td>
                        <td className='w-150'><input type='date' name='txtMedicationDate_5' id='txtMedicationDate_5' className='add-only' /></td>
                        <td className='w-200'><input type='text' name='txtMedicationPurpose_5' id='txtMedicationPurpose_5' className='add-only' /></td>
                        <td className='w-200'><input type='text' name='txtMedicationSideEffects_5' id='txtMedicationSideEffects_5' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'> Chemical Use History</span></p>

                <table>

                    <tr>
                        <td className='w-750'> Does the child/adolescent use or have a problem with alchol or drugs?</td>
                    </tr>
                    <tr>
                        <td ><input type='radio' id='rbProblemWithDrugYes' name='rbProblemWithDrug' className='add-only' value='ProblemWithDrugYes' /> Yes &nbsp;
                            <input type='radio' id='rbProblemWithDrugNo' name='rbProblemWithDrug' className='add-only' value='ProblemWithDrugNo' /> No</td>
                    </tr>

                    <tr>
                        <td className='w-750'> If yes, describe:&nbsp;
                            <input type='text' name='txtProblemWithDrugOther' id='txtProblemWithDrugOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><center><h3> Counselling/Prior Treatment History</h3></center></p>

                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'> Information about child/adolescent </span><span className='small'> (past and present):</span></td>
                        <td className='w-50'><span className='eleHeader'> Yes</span></td>
                        <td className='w-50'><span className='eleHeader'> No</span></td>
                        <td className='w-150'><span className='eleHeader'> When</span></td>
                        <td className='w-100'><span className='eleHeader'> Where</span></td>
                        <td className='w-250'><span className='eleHeader'> Reaction or overall experience</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'> Counseling/Psychiatric Treatment</td>
                        <td className='w-50'><center><input type='radio' name='rbPsychiatricTreatment' id='rbPsychiatricTreatmentYes' className='add-only' value='PsychiatricTreatmentYes' /></center></td>
                        <td className='w-50'><center><input type='radio' name='rbPsychiatricTreatment' id='rbPsychiatricTreatmentNo' className='add-only' value='PsychiatricTreatmentNo' /></center></td>
                        <td className='w-150'><input type='date' name='txtPsychiatricTreatmentWhen' id='txtPsychiatricTreatmentWhen' className='add-only' /></td>
                        <td className='w-100'><input type='text' name='txtPsychiatricTreatmentWhere' id='txtPsychiatricTreatmentWhere' className='add-only' /></td>
                        <td className='w-250'><input type='text' name='txtPsychiatricTreatmentReaction' id='txtPsychiatricTreatmentReaction' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'> Suicidal thoughts/attempts</td>
                        <td className='w-50'><center><input type='radio' name='rbSuicidalThoughts' id='rbSuicidalThoughtsYes' className='add-only' value='SuicidalThoughtsYes' /></center></td>
                        <td className='w-50'><center><input type='radio' name='rbSuicidalThoughts' id='rbSuicidalThoughtsNo' className='add-only' value='SuicidalThoughtsNo' /></center></td>
                        <td className='w-150'><input type='date' name='txtSuicidalThoughtsWhen' id='txtSuicidalThoughtsWhen' className='add-only' /></td>
                        <td className='w-100'><input type='text' name='txtSuicidalThoughtsWhere' id='txtSuicidalThoughtsWhere' className='add-only' /></td>
                        <td className='w-250'><input type='text' name='txtSuicidalThoughtsReaction' id='txtSuicidalThoughtsReaction' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'> Drug/alcohol treatment</td>
                        <td className='w-50'><center><input type='radio' name='rbAlcoholTreatment' id='rbAlcoholTreatmentYes' className='add-only' value='AlcoholTreatmentYes' /></center></td>
                        <td className='w-50'><center><input type='radio' name='rbAlcoholTreatment' id='rbAlcoholTreatmentNo' className='add-only' value='AlcoholTreatmentNo' /></center></td>
                        <td className='w-150'><input type='date' name='txtAlcoholTreatmentWhen' id='txtAlcoholTreatmentWhen' className='add-only' /></td>
                        <td className='w-100'><input type='text' name='txtAlcoholTreatmentWhere' id='txtAlcoholTreatmentWhere' className='add-only' /></td>
                        <td className='w-250'><input type='text' name='txtAlcoholTreatmentReaction' id='txtAlcoholTreatmentReaction' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'> Hospitalizations</td>
                        <td className='w-50'><center><input type='radio' name='rbHospitalizations' id='rbHospitalizationsYes' className='add-only' value='HospitalizationsYes' /></center></td>
                        <td className='w-50'><center><input type='radio' name='rbHospitalizations' id='rbHospitalizationsNo' className='add-only' value='HospitalizationsNo' /></center></td>
                        <td className='w-150'><input type='date' name='txtHospitalizationsWhen' id='txtHospitalizationsWhen' className='add-only' /></td>
                        <td className='w-100'><input type='text' name='txtHospitalizationsWhere' id='txtHospitalizationsWhere' className='add-only' /></td>
                        <td className='w-250'><input type='text' name='txtHospitalizationsReaction' id='txtHospitalizationsReaction' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Behavioral/Emotional </span>
                </p>
                <p className='w-750'><span className='small'>Please check any of the following that are typical for your child:</span></p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='cbAffectionate' id='cbAffectionate' className='add-only' value='Affectionate' /> Affectionate
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbAggresive' id='cbAggresive' className='add-only' value='Aggresive' /> Aggresive
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbAlcoholProblems' id='cbAlcoholProblems' className='add-only' value='AlcoholProblems' /> Alcohol problems
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbAngry' id='cbAngry' className='add-only' value='Angry' /> Angry
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='cbAnxiety' id='cbAnxiety' className='add-only' value='Anxiety' /> Anxiety
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbAttachmentDolls' id='cbAttachmentDolls' className='add-only' value='AttachmentDolls' /> Attachment to dolls
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbAvoidsAdults' id='cbAvoidsAdults' className='add-only' value='AvoidsAdults' /> Avoids adults
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbBedwetting' id='cbBedwetting' className='add-only' value='Bedwetting' /> Bedwetting
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='cbBlinkingJerking' id='cbBlinkingJerking' className='add-only' value='BlinkingJerking' /> Blinking, jerking
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbBizarreBehavior' id='cbBizarreBehavior' className='add-only' value='BizarreBehavior' /> Bizarre behavior
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbBulliesThreatens' id='cbBulliesThreatens' className='add-only' value='BulliesThreatens' /> Bullies, threatens
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbCarelessReckless' id='cbCarelessReckless' className='add-only' value='CarelessReckless' /> Careless, reckless
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='cbChestPains' id='cbChestPains' className='add-only' value='ChestPains' /> Chest pains
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbClumsy' id='cbClumsy' className='add-only' value='Clumsy' /> Clumsy
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbConfident' id='cbConfident' className='add-only' value='Confident' /> Confident
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbCooperative' id='cbCooperative' className='add-only' value='Cooperative' /> Cooperative
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='cbCyberAddiction' id='cbCyberAddiction' className='add-only' value='CyberAddiction' /> Cyber addiction
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbDefiant' id='cbDefiant' className='add-only' value='Defiant' /> Defiant
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbDepression' id='cbDepression' className='add-only' value='Depression' /> Depression
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbDestructive' id='cbDestructive' className='add-only' value='Destructive' /> Destructive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='cbDifficultySpeaking' id='cbDifficultySpeaking' className='add-only' value='DifficultySpeaking' /> Difficulty speaking
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbDizziness' id='cbDizziness' className='add-only' value='Dizziness' /> Dizziness
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbDrugsDependence' id='cbDrugsDependence' className='add-only' value='DrugsDependence' /> Drugs dependence
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbEnthusiastic' id='cbEnthusiastic' className='add-only' value='Enthusiastic' /> Enthusiastic
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='cbExcessiveMasturbation' id='cbExcessiveMasturbation' className='add-only' value='ExcessiveMasturbation' /> Excessive masturbation
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbExpectsFailure' id='cbExpectsFailure' className='add-only' value='ExpectsFailure' /> Expects failure
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbFearful' id='cbFearful' className='add-only' value='Fearful' /> Fearful
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbFrequentInjuries' id='cbFrequentInjuries' className='add-only' value='FrequentInjuries' /> Frequent injuries
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='cbFrustratedEasily' id='cbFrustratedEasily' className='add-only' value='FrustratedEasily' /> frfr
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbGambling' id='cbGambling' className='add-only' value='Gambling' /> Gambling
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbGenerous' id='cbGenerous' className='add-only' value='Generous' /> Generous
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbHallucinations' id='cbHallucinations' className='add-only' value='Hallucinations' /> Hallucinations
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='cbHeadBanging' id='cbHeadBanging' className='add-only' value='HeadBanging' /> Head banging
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbHeartProblems' id='cbHeartProblems' className='add-only' value='HeartProblems' /> Heart problems
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbHopelessness' id='cbHopelessness' className='add-only' value='Hopelessness' /> Hopelessness
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbHurtsAnimals' id='cbHurtsAnimals' className='add-only' value='HurtsAnimals' /> Hurts animals
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='cbImaginaryFriends' id='cbImaginaryFriends' className='add-only' value='ImaginaryFriends' /> Imaginary friends
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbImpulsive' id='cbImpulsive' className='add-only' value='Impulsive' /> Impulsive
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbIrritable' id='cbIrritable' className='add-only' value='Irritable' /> Irritable
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbLazy' id='cbLazy' className='add-only' value='Lazy' /> Lazy
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='cbLearningProblems' id='cbLearningProblems' className='add-only' value='LearningProblems' /> Learning problems
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbLiesFrequently' id='cbLiesFrequently' className='add-only' value='LiesFrequently' /> Lies frequently
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbListenReason' id='cbListenReason' className='add-only' value='ListenReason' /> Listen to reason
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbLoner' id='cbLoner' className='add-only' value='Loner' /> Loner
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='cbLowEsteem' id='cbLowEsteem' className='add-only' value='LowEsteem' /> Low self-esteem
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbMessy' id='cbMessy' className='add-only' value='Messy' /> Messy
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbMoody' id='cbMoody' className='add-only' value='Moody' /> Moody
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbNightmares' id='cbNightmares' className='add-only' value='Nightmares' /> Nightmares
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='cbObedient' id='cbObedient' className='add-only' value='Obedient' /> Obedient
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbOftenSick' id='cbOftenSick' className='add-only' value='OftenSick' /> Often sick
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbOppositional' id='cbOppositional' className='add-only' value='Oppositional' /> Oppositional
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbOverWeight' id='cbOverWeight' className='add-only' value='OverWeight' /> Over weight
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='cbPanicAttacks' id='cbPanicAttacks' className='add-only' value='PanicAttacks' /> Panic attacks
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbPhobias' id='cbPhobias' className='add-only' value='Phobias' /> Phobias
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbPoorAppetite' id='cbPoorAppetite' className='add-only' value='PoorAppetite' /> Poor appetite
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbPsychiatricProblems' id='cbPsychiatricProblems' className='add-only' value='PsychiatricProblems' /> Psychiatric problems
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='cbQuarrels' id='cbQuarrels' className='add-only' value='Quarrels' /> Quarrels
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbSad' id='cbSad' className='add-only' value='Sad' /> Sad
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbSelfish' id='cbSelfish' className='add-only' value='Selfish' /> Selfish
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbSeparationAnxiety' id='cbSeparationAnxiety' className='add-only' value='SeparationAnxiety' /> Separation anxiety
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='cbSetsFires' id='cbSetsFires' className='add-only' value='SetsFires' /> Sets fires
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbSexualAddiction' id='cbSexualAddiction' className='add-only' value='SexualAddiction' /> Sexual addiction
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbSexualOut' id='cbSexualOut' className='add-only' value='SexualOut' /> Sexual acting out
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbShares' id='cbShares' className='add-only' value='Shares' /> Shares
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='cbSickOften' id='cbSickOften' className='add-only' value='SickOften' /> Sick often
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbShortsSpan' id='cbShortsSpan' className='add-only' value='ShortsSpan' /> Shorts attention span
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbShyTimid' id='cbShyTimid' className='add-only' value='ShyTimid' /> Shy, timid
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbSleepingProblems' id='cbSleepingProblems' className='add-only' value='SleepingProblems' /> Sleeping problems
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='cbSlowMoving' id='cbSlowMoving' className='add-only' value='SlowMoving' /> Slow moving
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbSoiling' id='cbSoiling' className='add-only' value='Soiling' /> Soiling
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbSpeechProblems' id='cbSpeechProblems' className='add-only' value='SpeechProblems' /> Speech problems
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbSteals' id='cbSteals' className='add-only' value='Steals' /> Steals
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='cbStomachAches' id='cbStomachAches' className='add-only' value='StomachAches' /> Stomach aches
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbSuicidalAttempts' id='cbSuicidalAttempts' className='add-only' value='SuicidalAttempts' /> Suicidal attempts
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbTalksBack' id='cbTalksBack' className='add-only' value='TalksBack' /> Talks back
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbTeethGrinding' id='cbTeethGrinding' className='add-only' value='TeethGrinding' /> Teeth grinding
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='cbThumbSucking' id='cbThumbSucking' className='add-only' value='ThumbSucking' /> Thumb sucking
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbTicsTwitching' id='cbTicsTwitching' className='add-only' value='TicsTwitching' /> Tics or twitching
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbUnsafeBehaviors' id='cbUnsafeBehaviors' className='add-only' value='UnsafeBehaviors' /> Unsafe behaviors
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbWeightLoss' id='cbWeightLoss' className='add-only' value='WeightLoss' /> Weight loss
                        </td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='cbWithdrawn' id='cbWithdrawn' className='add-only' value='Withdrawn' /> Withdrawn
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbWorriesExcessively' id='cbWorriesExcessively' className='add-only' value='WorriesExcessively' /> Worries excessively
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='cbFatigue' id='cbFatigue' className='add-only' value='Fatigue' /> Fatigue
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='cbBehavioralOther' id='cbBehavioralOther' className='add-only' value='Other' /> Other:&nbsp;
                            <input type='text' name='txtBehavioralOther' id='txtBehavioralOther' className='add-only w-350 custom-add-only' /></td>
                    </tr>

                </table>

                <p className='w-750'><span className='eleHeader'> Please describe any of the above (or other) concerns:</span>

                    <textarea name='txtDescribeConcerns' id='txtDescribeConcerns' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'> How are problems generally handled:</span>

                    <textarea name='txtProblemsGenerallyHandled' id='txtProblemsGenerallyHandled' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'> What are the family&#39;s favorite activities?</span>

                    <textarea name='txtFavouriteActivities' id='txtFavouriteActivities' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'> What does the child/adolescent do with unstructured time?</span>

                    <textarea name='txtUnstructuredTime' id='txtUnstructuredTime' className='add-only'></textarea>
                </p>



                <table>
                    <tr>
                        <td className='w-500'><span className='eleHeader'> Have there been any significant change or events in your child&#39;s life? (family, moving, fire, death, etx)</span>
                        </td>
                        <td className='w-250'><span className='eleHeader'> What age:</span></td>

                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='radio' name='rbSignificantEvent' id='rbSignificantEventYes' className='add-only' /> Yes &nbsp;
                            <input type='radio' name='rbSignificantEvent' id='rbSignificantEventNo' className='add-only' /> No
                        </td>
                        <td className='w-250'><input type='text' id='txtSignificantEventAge' name='txtSignificantEventAge' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'> If Yes, describe:</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <textarea name='txtDescribeEvent' id='txtDescribeEvent' className='add-only'></textarea>
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'> Any additional information  that you believe would assist us in understanding your child/adolescent</span></p>
                <p className='w-750'><textarea name='txtUnderstandingChild' id='txtUnderstandingChild' className='add-only'></textarea></p>


                <p className='w-750'><span className='eleHeader'> Any additional information that would assist us in understanding current concerns or problems?</span></p>
                <p className='w-750'><textarea name='txtUnderstandingCurrentProblems' id='txtUnderstandingCurrentProblems' className='add-only'></textarea></p>


                <p className='w-750'><span className='eleHeader'> What are your goals for the child&#39;s therapy?</span></p>
                <p className='w-750'><textarea name='txtGoalsForChild' id='txtGoalsForChild' className='add-only'></textarea></p>


                <p className='w-750'><span className='eleHeader'> Do you believe the child is suicidal at this time?</span></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbChildIsSuicidalYes' name='rbChildIsSuicidal' className='add-only' value='SuicidalYes' /> Yes &nbsp;
                            <input type='radio' id='rbChildIsSuicidalNo' name='rbChildIsSuicidal' className='add-only' value='SuicidalNo' /> No
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'> If yes, explain:</td>
                    </tr>
                    <tr>
                        <td className='w-750'><textarea name='txtChildIsSuicidalExplain' id='txtChildIsSuicidalExplain' className='add-only'></textarea></td>
                    </tr>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Client&#39;s/Parents/Guardian Signature </td>
                    </tr>
                </table>


                <p className='w-750'><center><h2> For Staff Use</h2></center></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'> Therapist&#39;s comments:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea name='txtDescribeConcerns' id='txtDescribeConcerns' className='add-only'></textarea>
                        </td>
                    </tr>

                    <tr>
                        <td className='signature w-500'></td>
                        <td className='w-220'><input type='date' id='txtDateTherapist' name='txtDateTherapist' /></td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Therapist&#39;s/Paraprofessional&#39;s signature</td>&nbsp;
                        <td className='small w-220'> Date</td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'> Supervisor&#39;s comments:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea name='txtSupervisor' id='txtSupervisor' className='add-only'></textarea>
                        </td>
                    </tr>

                    <tr>
                        <td className='signature w-500'></td>
                        <td className='w-220'><input type='date' id='txtDateSupervisor' name='txtDateSupervisor' /></td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Supervisor&#39;s signature &nbsp;</td>&nbsp;
                        <td className='small w-220'> Date </td>
                    </tr>
                </table>

            </div>
        </form>

    )
}
